export default {
  // padroes de cores

  white: "hsl(0, 0%, 100%)",
  black: "rgb(0, 0, 0)",
  border: "hsl(0, 0%, 88%)",

  "info-dark": "hsla(215, 100%, 46%, 1)",
  info: "hsla(215, 100%, 58%, 1)",
  "info-light": "hsla(215, 100%, 85%, 1)",
  "info-lightest": "hsla(215, 100%, 97%, 1)",

  "success-dark": "hsla(163, 100%, 28%, 1)",
  success: "hsla(163, 100%, 36%, 1)",
  "success-light": "hsla(163, 55%, 85%, 1)",
  "success-lightest": "hsla(163, 60%, 95%, 1)",

  "warn-dark": "hsla(45, 94%, 48%, 1)",
  warn: "hsla(45, 91%, 64%, 1)",
  "warn-light": "hsla(45, 80%, 85%, 1)",
  "warn-lightest": "hsla(45, 90%, 95%, 1)",

  "danger-dark": "hsla(355, 75%, 55%, 1)",
  danger: "hsla(355, 75%, 60%, 1)",
  "danger-light": "hsla(355, 80%, 85%, 1)",
  "danger-lightest": "hsla(355, 88%, 96%, 1)",

  "base-900": "hsla(250, 5%, 10%, 1)",
  "base-800": "hsla(250, 2%, 11%, 1)",
  "base-700": "hsla(250, 6%, 13%, 1)",
  "base-600": "hsla(250, 6%, 19%, 1)",
  "base-400": "hsla(250, 6%, 51%, 1)",
  "base-300": "hsla(250, 7%, 78%, 1)",
  "base-200": "hsla(250, 9%, 89%, 1)",
  "base-170": "hsla(250, 7%, 94%, 1)",
  "base-150": "hsla(250, 5%, 96%, 1)",
  "base-100": "hsla(0, 0%, 100%, 1)",

  // backgrounds
  "body-background": "#EBF1F9",
  "background-menu": "#ffffff",
  bg: "#ffffff",
  overlay: "rgba(0, 0, 0, 0.75)",

  // texto

  text: "#030118",
  title: "hsla(215, 57%, 27%, 1)",
  label: "hsla(215, 57%, 27%, 1)",

  // custom

  main: "hsl(215, 57%, 27%)",
  hover: "hsl(215, 57%, 17%)",

  light: "hsl(215, 57%, 77%)",
  "light-hover": "hsl(215, 57%, 67%)",

  primary: "hsl(215, 57%, 27%)",
  "primary-light": "hsl(215, 57%, 57%)",
  "primary-lightest": "hsl(215, 57%, 90%)",

  // menu

  "menu-buttons": "hsl(249, 6%, 51%)",
  "menu-buttons-hover": "hsl(249, 6%, 31%)",
  "menu-buttons-destaque": "hsl(215, 57%, 27%)",
  "menu-buttons-destaque-hover": "hsl(215, 57%, 17%)",

  "arrow-buttons-background": "hsl(215, 57%, 27%)",
  "arrow-buttons-background-hover": "hsl(215, 57%, 37%)",
  "arrow-buttons-border": "hsl(215, 57%, 27%)",
  "arrow-buttons-border-hover": "hsl(215, 57%, 37%)",
  "arrow-buttons-icon": "#fff",
  "arrow-buttons-icon-hover": "#fff",

  // submenu

  "submenu-background": "#ffffff",
  "submenu-button-hover": "#fff",
  "submenu-button-active": "#1E3E6C",

  "submenu-button-text": "#2f2e33",
  "submenu-button-text-active": "#fff",
  "submenu-button-text-hover": "#2f2e33",

  // buttons

  "button-background": "#1E3E6C",
  "button-background-hover": "hsl(215, 57%, 47%)",
  "button-border": "#1E3E6C",
  "button-border-hover": "hsl(215, 57%, 47%)",
  "button-text": "#fff",
  "button-text-hover": "#fff",

  // submit button

  "submit-button-background": "#1E3E6C",
  "submit-button-background-hover": "hsl(215, 57%, 47%)",
  "submit-button-border": "#1E3E6C",
  "submit-button-border-hover": "hsl(215, 57%, 47%)",
  "submit-button-text": "#fff",
  "submit-button-text-hover": "#fff",

  // alternative button

  "alternative-button-background": "#1E3E6C",
  "alternative-button-background-hover": "hsl(215, 57%, 47%)",
  "alternative-button-border": "#1E3E6C",
  "alternative-button-border-hover": "hsl(215, 57%, 47%)",
  "alternative-button-text": "#fff",
  "alternative-button-text-hover": "#fff",

  // mirrored button

  "mirrored-button-background": "#fff",
  "mirrored-button-background-hover": "#1E3E6C",
  "mirrored-button-border": "#1E3E6C",
  "mirrored-button-border-hover": "#1E3E6C",
  "mirrored-button-text": "#1E3E6C",
  "mirrored-button-text-hover": "#fff",
  
    // Select button
    "select-button-background": "#1E3E6C",
    "select-button-background-hover": "#1E3E6C",
    "select-button-border": "#1E3E6C",
    "select-button-border-hover": "#1E3E6C",
    "select-button-text": "#fff",
    "select-button-text-hover": "#fff",
};



// WEBPACK FOOTER //
// ./src/styles/templates/default.js